import {useSelector} from "react-redux"

export const useConfig = () => {
  const commonData = useSelector(({common}) => common?.commonDetailsData || {})

  const {header_section} = commonData ?? {}

  const {allow_coupons, is_show_ecom_myorder_menu} = header_section ?? {}

  const allowCoupons = allow_coupons === "1"
  const showEcomMyOrderMenu = is_show_ecom_myorder_menu === "1"

  return {allowCoupons, showEcomMyOrderMenu}
}
